import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75a2144f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-4" }, [
    /*#__PURE__*/_createElementVNode("h3", {
      title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
      class: "fw-bold"
    }, "Our Trusted Clients")
  ])
], -1))
const _hoisted_3 = { class: "row justify-content-center align-items-center gx-3 gy-4" }
const _hoisted_4 = { class: "logo-wrapper position-relative text-center" }
const _hoisted_5 = {
  key: 0,
  title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
  href: "https://play.google.com/store/apps/details?id=com.dgymbook.app",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "logo-caption text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["client-section pt-navbar pb-5", { 'bg-light': !_ctx.isDarkMode, 'bg-dark': _ctx.isDarkMode }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["client-wrapper", {
        'client-wrapper-dark': _ctx.isDarkMode,
        'client-wrapper-light': !_ctx.isDarkMode
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-6 col-sm-4 col-md-3 col-lg-2 d-flex justify-content-center"
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.captions[index] === 'Dgymbook')
                  ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                      _createElementVNode("img", {
                        title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
                        src: logo,
                        alt: 'Client logo ' + (index + 1),
                        class: "client-logo"
                      }, null, 8, _hoisted_6)
                    ]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
                      src: logo,
                      alt: 'Client logo ' + (index + 1),
                      class: "client-logo"
                    }, null, 8, _hoisted_7)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.captions[index]), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ], 2))
}